interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

export default function LoadingSpinner({ size = 'md', text }: LoadingSpinnerProps) {
  const sizeMap = {
    sm: { width: 24, height: 24, border: 3 },
    md: { width: 40, height: 40, border: 4 },
    lg: { width: 60, height: 60, border: 5 },
  };
  
  const { width, height, border } = sizeMap[size];

  return (
    <div className="loading-spinner d-flex flex-column align-items-center gap-2">
      <div
        className="spinner"
        style={{
          width: `${width}px`,
          height: `${height}px`,
          borderWidth: `${border}px`,
        }}
      />
      {text && <span className="text-muted">{text}</span>}
    </div>
  );
}
